const set = ({ data, loadingState, oldData }) => {
  if (data?.items) {
    return {
      ...oldData,
      items: data?.items,
      totalItems: data?.totalItems,
      totalPages: data?.totalPages,
      page: data?.page,
      loading: false,
    }
  } else {
    if (!!loadingState) {
      return {
        ...oldData,
        data: data,
        loading: false,
      }
    } else {
      return data
    }
  }
}

export default set
